import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { useGetTaskPeriodicity } from '@/shared/hooks/task/useGetTaskPeriodicity';
import guid from '@/shared/utils/guid';
import { useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { listItemMsg } from '../../FormattedListValue';
import AutoComplete from '../select/AutoComplete';
export const TaskPeriodicitySelect = ({ initialValue, placeholder, taskTemplateId, isDisabled, onChange, }) => {
    const { formatMessage } = useIntl();
    const { data, refetch } = useGetTaskPeriodicity(taskTemplateId);
    useEffect(() => {
        refetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [taskTemplateId]);
    const taskPeriodicitys = useMemo(() => data === null || data === void 0 ? void 0 : data.map(item => ({
        key: item.id,
        label: formatMessage(listItemMsg('taskperiodicity', item.id, item.name)),
    })), [data, formatMessage]);
    const allItems = useMemo(() => [
        {
            key: guid.empty,
            label: formatMessage({ id: 'NoPeriodicity', defaultMessage: 'No periodicity' }),
        },
        ...(taskPeriodicitys !== null && taskPeriodicitys !== void 0 ? taskPeriodicitys : []),
    ], [taskPeriodicitys, formatMessage]);
    const initialSelectedItem = useMemo(() => { var _a; return (_a = (initialValue && (allItems === null || allItems === void 0 ? void 0 : allItems.find(item => (item === null || item === void 0 ? void 0 : item.key) === initialValue)))) !== null && _a !== void 0 ? _a : undefined; }, [initialValue, allItems]);
    return (_jsx(AutoComplete, { items: allItems, initialSelectedItem: initialSelectedItem, placeholder: placeholder, mode: "edit", onChange: item => onChange(item === null || item === void 0 ? void 0 : item.key), disabled: isDisabled }));
};
export const FilterTaskPeriodicitySelect = ({ item, taskTemplatesItem, setFilter, activeFilters, label, isAlwaysVisible, enabled, }) => {
    var _a;
    const taskTemplates = (_a = activeFilters[taskTemplatesItem]) !== null && _a !== void 0 ? _a : [];
    const taskTemplateId = taskTemplates.length === 1 ? taskTemplates[0] : null;
    return {
        enabled: enabled,
        filterItem: item,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        element: (_jsx(TaskPeriodicitySelect, { onChange: value => setFilter({ [item]: value !== null && value !== void 0 ? value : undefined }), initialValue: activeFilters[item], taskTemplateId: taskTemplateId, placeholder: label, isDisabled: !taskTemplateId })),
    };
};
